const EnvironmentBadge = () => {
  const env = process.env.REACT_APP_ENVIRONMENT;

  // Never show badge on production — check both env var AND hostname
  if (env === 'production' || !env) return null;
  if (typeof window !== 'undefined' && window.location.hostname === 'finncal.com') return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '10px',
        right: '10px',
        background: env === 'staging' ? 'orange' : 'red',
        color: 'white',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        fontWeight: 'bold',
        zIndex: 9999,
      }}
    >
      {env?.toUpperCase()}
    </div>
  );
};

export default EnvironmentBadge;
